import {Wrapper} from "./homeLayout.styles";
import {TopNavigationComponent} from "../../navigation/topNavigation/topNavigation.component";
import {Outlet} from "react-router";
import {SideNavigationComponent} from "../../navigation/sideNavigation/sideNavigation.component";
import {useState} from "react";
import {DrawerManagerComponent} from "../../drawerManager/drawerManager.component";

export const HomeLayoutComponent = () => {
    const [wrapSideNav, setWrapSideNav] = useState(() => {
        return localStorage.getItem("sideNavConfig") === "true"
    })
    return (<Wrapper>
        <DrawerManagerComponent />
        <SideNavigationComponent wrap={wrapSideNav}/>
        <aside style={{width: "100%"}}>
            <TopNavigationComponent setNavWrapState={setWrapSideNav}/>
            <main className={"cstScroll"}>
                <div className={"main-inner"}>
                    <Outlet/>
                </div>
            </main>
        </aside>
    </Wrapper>)
}